import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {Types}          from "@Common/types";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {AccountTabsLayout}      from "../../../common/account-tabs-layout/account-tabs-layout";
import {OfficeCreateModal}      from "./office-create-modal/office-create-modal";
import {OfficeManagementLayout} from "./office-management-layout";
import {ManagementModal}        from "./management-modal/management-modal";

export const AccountOfficeManagementRoute = () => cs(
    consumeContext("routerHistory"),
    (_, next)           => AccountTabsLayout({
        activeMenu: "officeManagement",
        activeTab: "office-management",
        config: [],
        overflow: true,
        next,
    }),
    consumeContext("apis"),
    ["officesLoad", ({apis}, next) => Load2({
        fetch: async () => apis.next.getBranchList(),
        next
    })],
    ({officesLoad, routerHistory}) => (<>
        {cs(
            ["queryParams", ({}, next) => next(parseUrlQuery(window.location.search))],
            ({queryParams}) => <>
                {OfficeCreateModal({
                    show: queryParams?.modal === "create",
                    reload: () => officesLoad.reload(),
                })}
                <ManagementModal
                    branchId={queryParams?.office}
                    onClose={() => routerHistory.replace(`/account/admin/office${queryParams?.search ? '?search=' + queryParams?.search : ''}`) }
                    onSave={(updatedOffice) => officesLoad.change(
                        (offices:Types.Apis.Payloads.Next.Branch.GetAll.Response) => offices.map(
                            office => office.idBranch === updatedOffice.idBranch ? updatedOffice : office
                        )
                    )}
                    onTabSwitch={(tabName) => (
                        routerHistory.replace(`/account/admin/office${buildUrlQuery({...queryParams, menu: tabName})}`)
                    )}
                    show={queryParams?.modal === "manage"}
                    tabName={queryParams?.menu}
                    officesReload={officesLoad.reload}
                />
            </>
        )}
        {OfficeManagementLayout({offices: officesLoad})}
    </>),
);

